import React, { FC, ReactElement } from 'react';
import { Alert } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import { localizeType } from '../../commonType';
import ViewDestination from '../../components/OfferDestination/DestinationInformation';
import { flipOffer, setFlipOfferDisplayMode } from '../../features/offerSearch/offerSearchSlice';
import { Offer } from '../../features/offerSearch/types';
import { RootState } from '../../redux/rootReducer';
import { VIEW_OFFERS_PATH } from '../../util/strings';
import withLocalization from '../hoc/withLocalization';
import './FlipOffer.scss';

interface FlipOfferPropType {
  flipOffers: Offer[] | [] | undefined;
  history?: any;
  localize?: localizeType;
  allFlipOffresExcluded: boolean;
}
const FlipOffer: FC<FlipOfferPropType> = (props: FlipOfferPropType): ReactElement => {
  const { flipOffers, localize, allFlipOffresExcluded } = props;
  const dispatch = useDispatch();
  const hasFlipOffers = flipOffers && flipOffers.length > 0;
  const displayFlipOffers: boolean = useSelector((state: RootState) => state.offerDetails.displayFlipOffers);

  const onShowFlipOfferClicked = (e) => {
    dispatch(setFlipOfferDisplayMode());
  };
  const onHandleClicked = (OfferCode: string) => {
    dispatch(flipOffer(OfferCode));
    props.history.push(VIEW_OFFERS_PATH);
  };
  return (
    <>
      {hasFlipOffers ? (
        <div className="container-flex propertyWrapper">
          {displayFlipOffers ? (
            <>
              <div className="flipOfferContainer">
                <div className="col-md-12 flipOfferText">
                  <h5 className="h3Mont palmColor upperCase">
                    {localize
                      ? localize('preview-sales-engine.static-content.copy.select-destination-page.sub-header')
                      : ''}
                  </h5>
                  <hr></hr>
                </div>
              </div>
              <div>
                {flipOffers && !allFlipOffresExcluded ? (
                  flipOffers.map((offer, index) => (
                    <ViewDestination
                      offer={offer}
                      key={index}
                      onViewOfferClicked={() => onHandleClicked(offer.offerCode)}
                    />
                  ))
                ) : allFlipOffresExcluded ? (
                  <>
                    <Alert variant="danger">
                      {localize
                        ? localize(
                            'preview-sales-engine.static-content.copy.select-destination-page.no-offers-found-for-selected-state-flip',
                          )
                        : ''}
                    </Alert>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </>
          ) : (
            <div className="row">
              <div className="col-md-12 text-center">
                <button className="btn btn-primary roomTypeSelectButton" onClick={onShowFlipOfferClicked}>
                  {localize
                    ? localize('preview-sales-engine.static-content.copy.select-destination-page.flip-button')
                    : ''}
                </button>
              </div>
            </div>
          )}
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default React.memo(withRouter(withLocalization(FlipOffer)));
